import { render, staticRenderFns } from "./diveCenter.vue?vue&type=template&id=066ad423&scoped=true&"
import script from "./diveCenter.vue?vue&type=script&lang=js&"
export * from "./diveCenter.vue?vue&type=script&lang=js&"
import style0 from "./diveCenter.vue?vue&type=style&index=0&id=066ad423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066ad423",
  null
  
)

export default component.exports